<div class="flex-row">
    @if (isBuildingConsultant.value) {
        <cb-my-client-sales-side-panel
            class="cb-margin"
            [clientSaleUpdated]="clientSaleUpdated"
            [currentClientSaleId]="currentClientSaleId"
            (currentClientSaleIdChange)="currentClientSaleChange($event)"
        >
        </cb-my-client-sales-side-panel>
    }
    @if (currentClientSaleId) {
        <cb-client-sale-view
            class="flex"
            [clientSaleId]="currentClientSaleId"
            [showTitle]="isBuildingConsultant.value"
            (clientSaleUpdated)="clientSaleUpdated.next($event)"
        >
        </cb-client-sale-view>
    }
    @if (!currentClientSaleId) {
        <div class="cb-margin-2x flex-col">
            @if (!loading) {
                <cb-info-message
                    message="No Client Sale has been selected"
                    iconClass="cb-grey"
                ></cb-info-message>
            }
            @if (loading) {
                <cb-loading-spinner></cb-loading-spinner>
            }
        </div>
    }
</div>
